import React from "react";
import { ThemeProvider } from "styled-components";

import Peracto from "@peracto/peracto";
import Config from "@peracto/peracto-config";
import PeractoUser from "@peracto/peracto-user";
import PeractoCatalogue from "@peracto/peracto-catalogue";
import PeractoCommon from "@peracto/peracto-common";
import PeractoContent from "@peracto/peracto-content";
import PeractoLocations from "@peracto/peracto-locations";
import PeractoPromotions from "@peracto/peracto-promotions";
import {
    Button,
    Checkbox,
    FormInput as Input,
    Textarea,
    Select,
    Radio,
    CheckboxGroup,
} from "./Inputs";

import {
    CustomerGroupsAdd,
    CustomerGroupsEdit,
    CustomerGroupsForm,
} from "./packages";

import { EditorTheme, AdminTheme, GlobalStyles } from "./theme";
import * as buttonVariants from "./Inputs/Button/variants";

import blocks from "./blocks";
import { menu } from "./menu";

import compact from "lodash/compact";
import startCase from "lodash/startCase";

const config = new Config({
    api: process.env.REACT_APP_API,
    algolia: {
        applicationId: process.env.REACT_APP_ALGOLIA_APPLICATION_ID,
        searchApiKey: process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY,
        indexName: process.env.REACT_APP_ALGOLIA_INDEX_NAME,
    },
    modules: [
        PeractoUser({
            CustomerGroupsAdd,
            CustomerGroupsEdit,
            CustomerGroupsForm,
        }),
        PeractoCommon(),
        PeractoCatalogue(),
        PeractoLocations(),
        PeractoPromotions(),
        PeractoContent(),
    ],
    editorConfig: {
        theme: EditorTheme,
        colorOptions: compact(
            Object.entries(EditorTheme.colors.brand).map(([label, value]) => {
                return { label: startCase(label), value };
            })
        ),
        locales: ["en_GB"],
        blocks,
        inputTypes: {
            Input,
            Textarea,
            Button,
            Select,
            Checkbox,
            CheckboxGroup,
            Radio,
        },
        headings: [
            {
                model: "hugeHeading",
                title: "Huge Heading",
                class: "ck-heading_heading1",
                view: {
                    name: "h2",
                    classes: "heading2-huge",
                },
                converterPriority: "high",
            },
        ],
        buttonVariants,
        stylesheets: ["https://use.typekit.net/khv0zch.css"],
        globalStyles: GlobalStyles,
    },
    features: {
        shippingServices: {
            deliveryDays: true,
            conditions: true,
        },
        products: {
            exportProductData: true,
            productVariants: true,
            additionalPriceTypes: ['procurementPrice'],
            customerGroupProductLinks: true,
        },
        content: {
            indexContent: true,
        },
    },
    menu,
});

const App = () => (
    <ThemeProvider theme={AdminTheme}>
        <Peracto config={config} />
    </ThemeProvider>
);

export default App;
